import { Default } from '@crochik/pi-react/context';
import App from '@crochik/pi-react/application/App';
import { Slot } from '@crochik/pi-react/ui/material/Calendar2';
import Dialog from '@crochik/pi-react/services/Dialog';

import { CalendarPage } from '../pages/Calendar';
import * as moment from 'moment-timezone';

import onSubmit from './Submit';
import { AppointmentFormState } from '../AppointmentForm';

function nextPage(state: AppointmentFormState) {
    // if for existing customer....
    var existingLead = Default.state.get('startArgs.auth', 'app');
    if ( existingLead ) {
        console.log('adding appointment to existing lead');
        Dialog.confirm({
            title: 'Schedule Appointment?',
            message: `You have selected ${state.localTime} on ${state.localDate}.`,
            onPositive: onSubmit,
            positiveCaption: 'Yes',
            negativeCaption: 'No',
        });
        return;
    }

    // new lead: get contact info
    App().selectPage('Appointment');
}

export function onClick(context: string, args: any[]) {
    var slot: Slot = args[0];
    console.log(`${context}: click slot: ${slot.date} ${slot.start}-${slot.start + slot.duration}`);

    const calendarPage = CalendarPage.state;
    calendarPage.selectedSlot = slot;
    var start = moment(slot.date).add(slot.start, 'minutes');
    var end = start.clone().add(slot.duration, 'minutes');
    
    var state: AppointmentFormState = Default.state.get('Appointment', 'form');
    Object.assign(state, {
        start: start.toDate(),
        end: end.toDate(),
        localDate: start.format('MM/DD/YYYY'),
        localTime: start.format('hh:mm A'),
        localStartMinutes: slot.start        
    });

    nextPage(state);
}

export function skipAppointment() {
    App().selectPage('Contact');
}


// WEBPACK FOOTER //
// ./src/app/actions/Calendar.ts